module.exports = __webpack_public_path__ + "static/media/facebook1.49aa5b59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/facebook1.svg
// module id = 486
// module chunks = 0